// Puente hacia el widget nativo de pantalla de inicio (Android).
//
// La webapp publica un snapshot chico (próximos turnos, racha) y el plugin
// nativo (WidgetBridgePlugin.java) lo FUSIONA clave a clave sobre lo ya
// publicado en SharedPreferences y refresca el widget (TuDiaWidget.java).
// Así cada flujo publica solo su parte (turnos desde App, racha desde su
// motor) sin pisarse entre sí.
//
// En web o iOS es un no-op silencioso: el widget es solo Android por ahora.

import { registerPlugin } from '@capacitor/core';
import { isNative, platform } from './platform';

const WidgetBridge = registerPlugin('WidgetBridge');

export async function publicarWidget(parcial) {
  if (!isNative || platform !== 'android') return;
  if (!parcial || typeof parcial !== 'object') return;
  try {
    await WidgetBridge.publicar({ datos: JSON.stringify(parcial) });
  } catch {
    // Plugin ausente (build antigua sin el widget): no es un error del flujo,
    // el widget simplemente no se refresca.
  }
}
